import { render, staticRenderFns } from "./ListaFinanceira..vue?vue&type=template&id=2573d4a3&"
import script from "./ListaFinanceira..vue?vue&type=script&lang=js&"
export * from "./ListaFinanceira..vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports